module.exports = __webpack_public_path__ + "static/media/img_join2.261c1ebb.png";